import { Box, Item, Text } from '@factorialco/deprecated-design-system'
import { CompaniesLegalEntity } from 'generated/resources/graphql'

import { WizardData } from 'modules/marketplace/lib/types'

import { LevelItem } from '../../LevelItem'

interface BusinessUnitsByLegalEntityProps {
  data: WizardData
  legalEntity: CompaniesLegalEntity
  employeeGroups: { id: number; name: string }[]
  onSelect: (employeeGroupId: string, value: string, label: string) => void
  isRefreshData: boolean
  isError: boolean
}

export const BusinessUnitsByLegalEntity = ({
  legalEntity,
  employeeGroups,
  onSelect,
  data,
  isRefreshData,
  isError,
}: BusinessUnitsByLegalEntityProps) => {
  const options: Item[] = JSON.parse(data.answers[`business_units_${legalEntity.id}`] ?? '[]')

  const findEmployeeGroup = (employeeGroupId: number) => {
    const selection = data.answers[`employee_group_${employeeGroupId}`]
    if (!selection) return ''

    return options.find((option) => option.value === selection)?.label || ''
  }

  return (
    <Box gap="s24">
      <Text.Header2>{legalEntity.legalName}</Text.Header2>
      {employeeGroups.map((employeeGroup) => (
        <LevelItem
          key={`employee_group_${employeeGroup.id}`}
          name={employeeGroup.name}
          selectedValue={findEmployeeGroup(employeeGroup.id)}
          options={options}
          onSelect={(value, label) => onSelect(employeeGroup.id.toString(), value, label)}
          loading={!isError && isRefreshData}
        />
      ))}
    </Box>
  )
}
